import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const application = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
const hasRenderedContent = container.dataset.rendered === 'true' && container.hasChildNodes();
export const root = hasRenderedContent
  ? ReactDOM.hydrateRoot(container, application)
  : ReactDOM.createRoot(container);
if (!hasRenderedContent) root.render(application);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
